/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
const DHL_TABS_VARIANTS = {
    HORIZONTAL: "horizontal",
    VERTICAL: "vertical",
};
const DHL_TABS_ORIENTATION = {
    TOP: "top",
    BOTTOM: "bottom",
    LEFT: "left",
    RIGHT: "right",
};
const DHL_TABS = {
    VARIANT: DHL_TABS_VARIANTS,
    ORIENTATION: DHL_TABS_ORIENTATION,
};

export { DHL_TABS as D };

//# sourceMappingURL=constants-362d9140.js.map